import * as TFF from '@tff/types/TFF';
import { FC } from 'react';
import { Link } from 'react-router-dom';

const BookingDetailsTable: FC<{
  details: { [k: string]: any };
  dbRetrieveItem: TFF.Retrieve | undefined;
  orderDetails: TFF.OrderDetails | undefined;
  flightDetails: TFF.FlightDetails | undefined;
}> = ({ details, dbRetrieveItem, flightDetails, orderDetails }): JSX.Element => {
  const atComDetails = () => {
    let promotionCode: string = '-';
    let promotionName: string = '-';
    let atcomRecordLocator: string = '-';

    if (dbRetrieveItem && 'reservationSystemDetails' in dbRetrieveItem) {
      const reservationSystemDetails = (dbRetrieveItem as TFF.BookedRetrieve).reservationSystemDetails;
      if (reservationSystemDetails && 'atcomres_cr' in reservationSystemDetails) {
        promotionCode = reservationSystemDetails.atcomres_cr.promoCode || '-';
        atcomRecordLocator = reservationSystemDetails.atcomres_cr.reservationSystemReferenceId || '-';
      }
    } else if (dbRetrieveItem && 'additionalParams' in dbRetrieveItem) {
      const additionalParams = (dbRetrieveItem as TFF.BookedRetrieve).additionalParams;
      if (additionalParams) {
        if ('promotion' in additionalParams && additionalParams.promotion) {
          const promotionParts = additionalParams.promotion.split('$');
          promotionCode = promotionParts[0] || '-';
          promotionName = promotionParts[1] || '-';
        }
        atcomRecordLocator = 'atComResBookingId' in additionalParams ? additionalParams.atComResBookingId || '-' : '-';
      }
    }

    return `Promotion Code:\t\t${promotionCode}\nPromotion Name:\t\t${promotionName}\nATCOM-Record-Locator:\t${atcomRecordLocator}`;
  };

  return (
    <table>
      <tbody>
        {Object.keys(details)
          .filter(infoKey => details[infoKey].display === undefined || details[infoKey].display)
          .sort()
          .map(infoKey => {
            return (
              <tr key={infoKey}>
                <td style={{ paddingRight: '30px', verticalAlign: 'top', paddingTop: '10px', fontWeight: 'bold' }}>
                  {details[infoKey].label ?? infoKey}
                </td>
                {Array.isArray(details[infoKey].value) && (
                  <td style={{ whiteSpace: 'pre', paddingTop: '10px' }}>
                    <table>
                      <tbody>
                        {details[infoKey].value.map(subDetails => {
                          return (
                            <tr key={subDetails[0]}>
                              <td style={{ paddingRight: '30px', verticalAlign: 'top' }}>{subDetails[0]}</td>
                              <td style={{ whiteSpace: 'pre' }}>{subDetails[1] || '-'}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </td>
                )}
                {!Array.isArray(details[infoKey].value) && (
                  <td style={{ whiteSpace: 'pre', paddingTop: '10px' }}>{details[infoKey].value ?? '-'}</td>
                )}
              </tr>
            );
          })}
        {dbRetrieveItem?.product === 'atcomres' && (
          <tr>
            <td style={{ paddingRight: '30px', verticalAlign: 'top', paddingTop: '10px', fontWeight: 'bold' }}>
              ATCOM Details
            </td>
            <td style={{ whiteSpace: 'pre', paddingTop: '10px' }}>{atComDetails()}</td>
          </tr>
        )}
        {flightDetails?.OrderSummary?.ChildRecordLocators && (
          <>
            <td
              style={{
                paddingRight: '30px',
                verticalAlign: 'top',
                paddingTop: '10px',
                fontWeight: 'bold',
              }}
            >
              Child PNR
            </td>
            <table>
              <tbody>
                {flightDetails.OrderSummary?.ChildRecordLocators.map((childRecord, i) => {
                  return (
                    <tr key={childRecord}>
                      <td
                        style={{
                          paddingTop: `${i === 0 ? '10px' : ''}`,
                          verticalAlign: 'top',
                        }}
                      >
                        <Link to={`../${childRecord.trim()}@${dbRetrieveItem?.bookingSource}`}>{childRecord}</Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
        {flightDetails?.OrderSummary?.ParentRecordLocator && (
          <>
            <td
              style={{
                paddingRight: '30px',
                verticalAlign: 'top',
                paddingTop: '10px',
                fontWeight: 'bold',
              }}
            >
              Parent PNR
            </td>

            <td style={{ whiteSpace: 'pre', paddingTop: '10px' }} key={flightDetails.OrderSummary.ParentRecordLocator}>
              <Link to={`../${flightDetails.OrderSummary.ParentRecordLocator}@${dbRetrieveItem?.bookingSource}`}>
                {flightDetails.OrderSummary.ParentRecordLocator}
              </Link>
            </td>
          </>
        )}
      </tbody>
    </table>
  );
};

export default BookingDetailsTable;
